import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80ca0a3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pin-row" }

import { computed } from 'vue';

export type Props = {
  pinLength: number,
  value?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PinRow',
  props: {
    pinLength: null,
    value: { default: '' }
  },
  setup(__props: any) {

const props = __props as { pinLength: number, value: string };



const charPositions = computed(() => {
  const positions = [];
  let i = 0;

  for (i; i < props.pinLength; i++) {
    positions.push(i);
  }
  return positions;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(charPositions), (charPos) => {
      return _renderSlot(_ctx.$slots, "default", {
        key: charPos,
        pinPos: charPos,
        pinDigit: __props.value[charPos]
      })
    }), 128))
  ]))
}
}

})